import React from 'react'
import { SidebarItem } from 'Core/Workbench'
import { isDivider } from 'Components/common/Sidebar/Sidebar'
import classes from './SidebarItemPanel.module.less'

type SidebarItemPanel = {
    sidebarItems: SidebarItem[]
    activeItem: string | undefined
}

export const SidebarItemPanel: React.FC<SidebarItemPanel> = ({ sidebarItems, activeItem }) => {
    return sidebarItems
        .filter(item => !isDivider(item))
        .map(item => {
            if (item.destroyOnClose && item.id !== activeItem) {
                // returning an empty fragment to avoid rendering the element
                return <React.Fragment key={item.id} />
            }
            return (
                <div
                    className={classes.activeItemContainer}
                    // only hiding the element, not removing it from the DOM
                    style={{
                        display: item.id === activeItem ? 'block' : 'none',
                    }}
                    key={item.id}
                >
                    {item.element}
                </div>
            )
        })
}
